// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__-i7XM","moreInfo":"TopMenu_moreInfo__ARwaR","logo":"TopMenu_logo__MuCwt","menuTrigger":"TopMenu_menuTrigger__x-V56","closed":"TopMenu_closed__KM+38"};